import { gql } from '@apollo/client/core';

export const GET_TOUR_MATCHES_BY_PLAYER = gql`
    query GetTourMatchesByPlayer($player: ID!, $page: Int!, $pageSize: Int!, $keyword: String!) {
        tourMatches_connection(
            filters: {
                and: [
                    {
                        or: [
                            { tour_player_team_1: { player_1: { documentId: { eq: $player } } } },
                            { tour_player_team_1: { player_2: { documentId: { eq: $player } } } },
                            { tour_player_team_2: { player_1: { documentId: { eq: $player } } } },
                            { tour_player_team_2: { player_2: { documentId: { eq: $player } } } }
                        ]
                    },
                    {
                        or: [
                            { tournament: { name: { contains: $keyword } } },
                            { match_code: { contains: $keyword } }
                        ]
                    }
                ]
            }
            pagination: { page: $page, pageSize: $pageSize }
            sort: ["createdAt:desc"]
        ) {
            nodes {
                documentId
                start_date
                match_code
                umpire {
                    documentId
                    name
                }
                tour_player_team_1 {
                    documentId
                    player_1 {
                        documentId
                        display_name
                        phone
                        address
                    }
                    player_2 {
                        documentId
                        display_name
                        phone
                        address
                    }
                }
                tour_player_team_2 {
                    documentId
                    player_1 {
                        documentId
                        display_name
                        phone
                        address
                    }
                    player_2 {
                        documentId
                        display_name
                        phone
                        address
                    }
                }
                tournament {
                    name
                    contact_address
                    contact_phone
                    award_total
                    num_player
                    tour_status
                    date_start
                    date_end
                    reg_start_date
                    reg_end_date
                    rule
                    photo {
                        documentId
                        url
                    }
                    arenas {
                        name
                        address
                        courts {
                            name
                        }
                    }
                }
                tour_match_status
                score
                score_detail
                court {
                    name
                    arena {
                        name
                        address
                    }
                }
                round {
                    name
                }
                winner {
                    documentId
                    player_1 {
                        documentId
                        display_name
                        phone
                        address
                    }
                    player_2 {
                        documentId
                        display_name
                        phone
                        address
                    }
                }
                category {
                    name
                }
                court {
                    name
                    arena {
                        name
                        contact_phone
                        address
                    }
                }
            }
            pageInfo {
                page
                pageCount
                pageSize
                total
            }
        }
    }
`;

export const GET_TOUR_MATCHES = gql`
    query GetTourMatchesByTournament(
        $filters: TourMatchFiltersInput
        $pagination: PaginationArg
        $sort: [String!]
    ) {
        tourMatches_connection(
            filters: $filters
            pagination: $pagination
            sort: $sort
        ) {
            meta {
                pagination {
                    total
                    pageCount
                    page
                    pageSize
                }
            }
            nodes {
                documentId
                score_detail
                replay_url
                court {
                    name
                    arena {
                        name
                        contact_phone
                        address
                    }
                }
                umpire {
                    documentId
                    name
                }
                match_code
                score
                start_date
                set_times
                category {
                    name
                    type
                }
                tour_match_status
                tour_category
                winner {
                    documentId
                    player_1 {
                        documentId
                        display_name
                        phone
                        address
                    }
                    player_2 {
                        documentId
                        display_name
                        phone
                        address
                    }
                }
                num_round
                round {
                    name
                    type
                    num_round
                }
                tour_player_team_1 {
                    player_1 {
                        last_name
                        first_name
                        middle_name
                        display_name
                    }
                    player_2 {
                        last_name
                        first_name
                        middle_name
                        display_name
                    }
                }
                tour_player_team_2 {
                    player_1 {
                        last_name
                        first_name
                        middle_name
                        display_name
                    }
                    player_2 {
                        last_name
                        first_name
                        middle_name
                        display_name
                    }
                }
            }
        }
    }
`;

export const GET_CATEGORIES = gql`
  query GetCategories($documentId: ID!, $page: Int!, $pageSize: Int!) {
    categories_connection(
      filters: { tournament: { documentId: { eq: $documentId } } }
      pagination: { page: $page, pageSize: $pageSize }
      sort: ["createdAt:desc"]
    ) {
      nodes {
        documentId
        name
        num_award
        num_player
        start_date
        end_date
        note
        age
        description
        type
        tour_matches {
          documentId
          tour_match_status
        }
      }
      pageInfo {
        page
        pageCount
        pageSize
        total
      }
    }
  }
`;